module.exports = __webpack_public_path__ + "img/VillaLoreto_Room2.6c6664d9.jpg";